"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Add;

var _Add = require("@adobe/react-spectrum-workflow/dist/Add.js");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Add(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Add.A4uAdd, null));
}